import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { BrowserView, MobileView } from "react-device-detect";

import { Message } from "@templates";
import { Container } from "@molecules";

export default function Prospects() {
  const { token } = useParams();

  const handleCopyClic = () => {
    navigator.clipboard.writeText(token);
    toast("¡Listo! Se copió el código", {
      theme: "dark",
    });
  };

  return (
    <Container>
      <Message>
        <Message.Emoji>📲 </Message.Emoji>
        <Message.Title>
          <BrowserView renderWithFragment>¡Uy lo sentimos!</BrowserView>
          <MobileView renderWithFragment>
            <span class="prospects-mobile-title"> Completá tu registro</span>
          </MobileView>
        </Message.Title>
        <Message.Body>
          <BrowserView renderWithFragment>
            Abrí el link desde tu celular con la app de Nubi para continuar con
            tu registro.
          </BrowserView>
          <MobileView renderWithFragment>
            <div class="prospects-mobile-container">
              <div class="prospects-mobile-container-title">
                Seguí los pasos para activar tu tarjeta Visa:
              </div>
              <div class="prospects-mobile-container-desc">
                <span>1. Copiá tu código de registro</span>
                <br />
                <span>
                  2. Entrá a <b>Nubi</b> y tocá en <b>Completar mi registro</b>
                </span>
                <br />
                <span>
                  3. Pegá el código y tocá en <b>Continuar</b>
                </span>
                <br />
                <span>
                  4. Revisá tus datos personales y completá tu alta 🎉
                </span>
              </div>
              <div>
                <button class="button-primary" onClick={handleCopyClic}>
                  <span class="button-primary-text">Copiar código</span>
                </button>
                <br />
                <div>
                  <p class="prospects-token">Código de registro:</p>
                  <p class="prospects-token"> {token}</p>
                </div>
              </div>
            </div>
          </MobileView>
        </Message.Body>
        <Message.Footer>
          Si necesitás ayuda escribinos a{" "}
          <a href="mailto:hola@nubi.com.ar">hola@nubi.com.ar</a>
        </Message.Footer>
      </Message>
    </Container>
  );
}
